import React from "react";

const ClientMap = ({ client, onBack }) => {
  const fullAddress = [
    client?.address1,
    client?.address2,
    client?.city,
    client?.province,
    client?.postalCode,
    client?.country,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div className="gog-client-map">
      <div className="gog-inner-section-header">
        <span>Map</span>
        <h3>Merchant Location</h3>
        <p>
          {fullAddress || "No address is available for this merchant."}
        </p>
      </div>

      {fullAddress ? (
        <div className="gog-map-frame-wrap">
          <iframe
            title="client-map"
            loading="lazy"
            allowFullScreen
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              fullAddress
            )}&output=embed`}
          />
        </div>
      ) : (
        <div className="gog-empty-state">
          The map cannot be displayed because this merchant does not have a full
          address.
        </div>
      )}

      <div className="gog-inner-action-row">
        <button type="button" onClick={onBack} className="gog-light-btn">
          Back
        </button>
      </div>
    </div>
  );
};

export default ClientMap;